import useSimilarAndOtherCourses from '@api/hooks/class/useSimilarAndOtherCourses';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import {
  getFullDate,
  getHoursMinutesValueFromSeconds,
  getTimeDifference
} from '@utils/dates';
import Typography from 'aquilla/core/atoms/Typography';
import getTextColor from 'aquilla/core/shared/utils/getTextColor';
import React from 'react';
import Link from '@base/Link/Link';
import { Tag } from 'aquilla/core/atoms/Tag';
import { Eye } from 'aquilla/icons/misc/Eye';
import { formatClassDetail, getClassCard } from '../utils';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_4B};
  height: 620px;
  overflow: scroll;
`;

const ClassPlayCard = styled.div`
  display: flex;
  gap: ${Spacings.SPACING_3B};
  cursor: pointer;
`;

const PreviewWrapper = styled.div`
  position: relative;
  border-radius: ${Spacings.SPACING_2B};
  flex-shrink: 0;
  overflow: hidden;
  [class*='ClassThumbnailWrapper'] {
    width: unset;
    display: flex;
  }
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_6};
`;

const ClassTitle = styled(Typography)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const ClassViewCountTag = styled(Tag)`
  border: none;
  display: flex;
  gap: ${Spacings.SPACING_1B};
  font-weight: 600;
  position: absolute;
  bottom: 4px;
  left: 4px;
`;

const getInfoString = (lesson) => {
  return getHoursMinutesValueFromSeconds(
    getTimeDifference(lesson.startsAt, lesson.endsAt, false, true)
  );
};
const ClassCard = ({ classInfo }) => {
  const {
    thumbnail: Preview,
    title,
    infoString,
    educatorName,
    educatorLink,
    viewCount,
    onClick
  } = classInfo;
  return (
    <ClassPlayCard onClick={onClick}>
      <PreviewWrapper>
        <Preview />
        {viewCount ? (
          <ClassViewCountTag size="small" variant="default">
            <Eye height={12} width={12} /> {viewCount}
          </ClassViewCountTag>
        ) : (
          ''
        )}
      </PreviewWrapper>
      <InfoWrapper>
        <ClassTitle variant="h6" color="var(--color-text-primary)">
          {title}
        </ClassTitle>
        <Link href={educatorLink}>
          <Typography variant="p3" color="var(--color-text-secondary)">
            {educatorName}
          </Typography>
        </Link>
        <Typography variant="p3" color="var(--color-text-secondary)">
          {infoString}
        </Typography>
      </InfoWrapper>
    </ClassPlayCard>
  );
};
const SimilarClasses = ({ classUID, type = 0 }) => {
  const { similarAndOtherCourses } = useSimilarAndOtherCourses(classUID);
  const handleCardClick = (onClick) => () => {
    onClick();
  };

  if (
    similarAndOtherCourses[type]?.data &&
    similarAndOtherCourses[type]?.data.length !== 0
  )
    return (
      <Container>
        {similarAndOtherCourses[type].data.map((lesson, i) => {
          const { onClick, ...classCardProps } = formatClassDetail({
            classInfo: lesson
          });
          return (
            <ClassCard
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              classInfo={{
                ...classCardProps,
                onClick: handleCardClick(onClick),
                infoString: `${getFullDate(lesson.startsAt)} • ${getInfoString(
                  lesson
                )}`,
                thumbnail: getClassCard(
                  lesson.coverPhotoV1,
                  getTextColor(lesson.topicGroups[0]?.name[0] || ''),
                  160,
                  90
                )
              }}
            />
          );
        })}
      </Container>
    );
  return null;
};

export default SimilarClasses;
